import { jsx as _jsx } from "react/jsx-runtime";
import Collapse from '@hellodarwin/core/lib/components/common/Collapse';
import { useTranslation } from 'react-i18next';
import getTestId from '../../../../../tests/utils/get-test-id';
import { AssistantMessageFormatter } from '../../../services/AssistantMessageFormatter';
import { ToolStatus } from '../../../types/tool.types';
import { CollapsibleSection, ToolError, ToolResult } from '../styles';
export const ToolJsonResultSection = ({ tool, status, expandedSections, setExpandedSections, }) => {
    const { t } = useTranslation();
    if (status === ToolStatus.FAILURE) {
        return (_jsx(ToolError, { children: tool.error && tool.error.startsWith('assistant.')
                ? t(tool.error, 'An unknown error occurred')
                : tool.error ||
                    t('assistant.tool_error_unknown', 'An unknown error occurred') }));
    }
    if (!tool.result) {
        return null;
    }
    const result = AssistantMessageFormatter.formatToolResult(tool);
    const resultItems = [
        {
            id: 'result',
            title: t('assistant.tool_result', 'Result'),
            children: (_jsx(ToolResult, Object.assign({}, getTestId('assistant-tool-result'), { children: _jsx("pre", { children: JSON.stringify(result, null, 2) }) }))),
        },
    ];
    return (_jsx(CollapsibleSection, { children: _jsx(Collapse, { activeKey: expandedSections, onChange: (keys) => setExpandedSections(keys), ghost: true, items: resultItems }) }));
};
export default ToolJsonResultSection;
